import(/* webpackMode: "eager" */ "/mom-baby-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/mom-baby-web/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/mom-baby-web/node_modules/@aph/ui-lib-humanx/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mom-baby-web/src/redux/app/index.tsx");
;
import(/* webpackMode: "eager" */ "/mom-baby-web/src/styles/global.scss");
;
import(/* webpackMode: "eager" */ "/mom-baby-web/src/styles/icomoon/style.css");
